import { Grid, SelectChangeEvent } from '@mui/material'
import {
  DateRange,
  FormikSelect,
  FormikSubmitButton,
  FormikTextField
} from '../../../../components'
import { useFieldProps } from '../../../../hooks'
import {
  ACCRUAL_BASE_TYPE_EUROS,
  ACCRUAL_BASE_TYPE_PERCENTAGE
} from '../../constants'

interface CalculateMembershipFeeFormContentProps {
  defaultAccrualBaseAmount?: string
  defaultAccrualBaseType: string
}

export const CalculateMembershipFeeFormContent = ({
  defaultAccrualBaseAmount,
  defaultAccrualBaseType
}: CalculateMembershipFeeFormContentProps) => {
  const { setValue: setAmountValue } = useFieldProps('amount')
  const { setValue: setGrossSalaryValue } = useFieldProps('grossSalary')
  const { value: typeValue } = useFieldProps('type')

  const handleTypeChange = (event: SelectChangeEvent<unknown>) => {
    if (event.target.value === defaultAccrualBaseType) {
      setAmountValue(defaultAccrualBaseAmount)
    } else {
      setAmountValue('')
    }
    if (event.target.value === ACCRUAL_BASE_TYPE_EUROS) {
      setGrossSalaryValue('')
    }
  }

  return (
    <Grid container spacing={2} columns={13}>
      <Grid item md={5} xs={12}>
        <DateRange
          endDateProps={{
            labelTranslationId:
              'pages.membershipFeesPage.calculateMembershipFeePage.endDate',
            required: true,
            name: 'endDate'
          }}
          startDateProps={{
            labelTranslationId:
              'pages.membershipFeesPage.calculateMembershipFeePage.startDate',
            required: true,
            name: 'startDate'
          }}
          spacing={2}
        />
      </Grid>
      <FormikTextField
        gridProps={{ md: 3 }}
        labelTranslationId="pages.membershipFeesPage.calculateMembershipFeePage.grossSalary"
        name="grossSalary"
        disabled={typeValue === ACCRUAL_BASE_TYPE_EUROS}
        required={typeValue === ACCRUAL_BASE_TYPE_PERCENTAGE}
      />
      <FormikTextField
        gridProps={{ md: 2 }}
        labelTranslationId="pages.membershipFeesPage.calculateMembershipFeePage.amount"
        name="amount"
        required
      />
      <FormikSelect
        gridProps={{ md: 1 }}
        executeOnChangeFn={handleTypeChange}
        name="type"
        options={[ACCRUAL_BASE_TYPE_PERCENTAGE, ACCRUAL_BASE_TYPE_EUROS].map(
          (type) => ({ value: type, display: type })
        )}
      />
      <Grid item md={2}>
        <FormikSubmitButton
          buttonProps={{
            fullWidth: true,
            translationId:
              'pages.membershipFeesPage.calculateMembershipFeePage.calculate'
          }}
        />
      </Grid>
    </Grid>
  )
}
